import { render } from "./ProjectStretchGoalCard.vue?vue&type=template&id=49d5b4fe"
import script from "./ProjectStretchGoalCard.vue?vue&type=script&lang=js"
export * from "./ProjectStretchGoalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__